module.exports = __webpack_public_path__ + "static/img/imgYouKu2.52e0636.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/youkuCard/imgYouKu2.png
// module id = vRDn
// module chunks = 1